
<template>
  <footer class="py-4 bg-white">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 text-center text-md-start">
          <p class="mb-0">
            &copy; {{ currentYear }} neolinks. {{ t('footer.copyright') }}
            <a href="https://opentek.co" class="text-dark opacity-25 ms-1 small  d-none text-decoration-none" target="_blank" rel="noopener noreferrer">opentek</a>
          </p>
        </div>
        <div class="col-md-6 text-center text-md-end d-none">
          <a href="#" class="text-dark me-2">
            <i class="fab fa-facebook-f"></i>
          </a>
          <a href="#" class="text-dark me-2">
            <i class="fab fa-twitter"></i>
          </a>
          <a href="#" class="text-dark me-2">
            <i class="fab fa-instagram"></i>
          </a>
          <a href="#" class="text-dark">
            <i class="fab fa-linkedin-in"></i>
          </a>
        </div>
      </div>
    </div>
    
    <!-- Back to Top Button -->
    <button 
       v-show="showBackToTop"
       class="back-to-top"
       @click="scrollToTop"
       :aria-label="t('footer.backToTop')">
      <i class="fas fa-arrow-up"></i>
    </button>
  </footer>
</template>


<script>
// AJOUTER cette ligne en haut :
import { useTranslation } from '@/composables/useTranslation'

export default {
  name: "Footer",
  // AJOUTER cette fonction :
  setup() {
    const { t } = useTranslation()
    return { t }
  },
  // TON CODE EXISTANT RESTE IDENTIQUE :
  data() {
    return {
      showBackToTop: false,
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 200;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
/* Footer styling */
.text-dark {
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 0.7;
  }
}

/* Back to Top Button Styling */
.back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: black;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 1000;
}

.back-to-top i {
  font-size: 18px; /* Adjust icon size */
}

.back-to-top:hover {
  opacity: 0.8;
  transform: scale(1.1);
}

.back-to-top[v-cloak] {
  display: none;
}
</style>